import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api, { InviteCollaboratorCommand, UpdateCollaboratorsCommand } from "../../api";

interface CollaboratorSliceState {
}

const initialState: CollaboratorSliceState = {};

export const getCollaborators = createAsyncThunk(
	"collaborator/getCollaborators",
	async (data: { projectId: number, pageNum: number, pageSize: number }) => {
		return await api.getProjectCollaborators(data.projectId, data.pageNum, data.pageSize);
	},
);

export const deleteCollaborator = createAsyncThunk(
	"collaborator/deleteCollaborator",
	async (data: { projectId: number, collaboratorId: number }) => {
		return await api.deleteProjectCollaborator(data.collaboratorId, data.projectId);
	},
);

export const updateCollaborator = createAsyncThunk(
	"collaborator/updateCollaborator",
	async (data: UpdateCollaboratorsCommand) => {
		return await api.updateProjectCollaborators(data);
	},
);

export const getInvitationInfo = createAsyncThunk(
	"collaborator/getInvitationInfo",
	async (invitationId: number) => {
		return await api.getInvitationInfo(invitationId);
	},
);

export const getInvitationsForUser = createAsyncThunk(
	'collaborator/getInvitationsForUser',
	async (userEmail: string | undefined) => {
		return await api.getUserInvitations(userEmail);
	},
);

export const acceptInvitation = createAsyncThunk(
	"collaborator/acceptInvitation",
	async (invitationId: number | undefined) => {
		return await api.acceptInvitation({ invitationId });
	},
);

export const declineInvitation = createAsyncThunk(
	"collaborator/declineInvitation",
	async (invitationId: number | undefined) => {
		return await api.declineInvitation({ invitationId });
	},
);

export const inviteCollaborator = createAsyncThunk(
	"collaborator/inviteCollaborator",
	async (command: InviteCollaboratorCommand | undefined) => {
		return await api.inviteProjectCollaborator(command);
	},
);

const collaboratorSlice = createSlice({
	name: 'collaborator',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
	},
});

const { reducer } = collaboratorSlice;

export default reducer;